import axios from 'axios';

export interface VimeoVideo {
  id: number;
  title: string;
  description: string;
  duration: number;
  thumbnail_small: string;
  thumbnail_medium: string;
  thumbnail_large: string;
}

export function getVideoEmbedUrl(videoId: string) {
  return `https://player.vimeo.com/video/${videoId}`;
}

export async function getVideoInfo(
  videoId: string,
): Promise<VimeoVideo | null> {
  const { data } = await axios.get<VimeoVideo[]>(
    `https://vimeo.com/api/v2/video/${videoId}.json`,
  );

  if (data.length > 0) {
    return data[0];
  }

  return null;
}

export async function getVideoThumbnailUrl(videoId: string): Promise<string> {
  const { data } = await axios.get<{ thumbnail_url: string }>(
    `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`,
  );

  return data.thumbnail_url;
}
